<mat-card>
  <div class="grid grid-cols-1 gap-y-6">
    <div>
      <div class="flex justify-between">
        <div class="text-white uppercase">Wallet Directory</div>
        <mat-icon
          aria-hidden="false"
          aria-label="Example home icon"
          class="text-muted mt-1 text-base cursor-pointer"
          [matTooltip]="walletDirTooltip">
          help_outline
        </mat-icon>
      </div>
      <div class="text-primary text-base mt-2">
        {{wallet?.wallet_path}}
      </div>
    </div>
    <div *ngIf="wallet?.keymanager_kind === 'IMPORTED'">
      <div class="flex justify-between">
        <div class="text-white uppercase">Accounts Keystore File</div>
        <mat-icon
          aria-hidden="false"
          aria-label="Example home icon"
          class="text-muted mt-1 text-base cursor-pointer"
          [matTooltip]="keystoreTooltip">
          help_outline
        </mat-icon>
      </div>
      <div class="text-primary text-base mt-2">
        {{wallet?.wallet_path}}/direct/accounts/all-accounts.keystore.json
      </div>
    </div>
    <div *ngIf="wallet?.keymanager_kind === 'DERIVED'">
      <div class="flex justify-between">
        <div class="text-white uppercase">Encrypted Seed File</div>
        <mat-icon
          aria-hidden="false"
          aria-label="Example home icon"
          class="text-muted mt-1 text-base cursor-pointer"
          [matTooltip]="encryptedSeedTooltip">
          help_outline
        </mat-icon>
      </div>
      <div class="text-primary text-base mt-2">
        {{wallet?.wallet_path}}/derived/seed.encrypted.json
      </div>
    </div>
  </div>
</mat-card>
